<template>
  <VueJsonToCsv
    :json-data="list"
    :separator="';'"
    :csv-title="`${csvName}_CSV`"
  >
    <BaseButtonComponent block variant="primary-action">
      CSV
    </BaseButtonComponent>
  </VueJsonToCsv>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv';
import { BaseButtonComponent } from '../buttons';

export default {
  components: {
    VueJsonToCsv,
    BaseButtonComponent,
  },
  props: {
    list: {
      type: Array,
      default: [],
      required: true,
    },
    csvName: {
      type: String,
      default: 'JSON',
      required: true,
    },
  },
};
</script>
